import React from 'react';

const DEFAULT_STYLE = {
  fontSize: '0.75rem',
  minWidth: 700,
  borderCollapse: 'separate',
  borderSpacing: 0,
  marginBottom: 0,
  backgroundClip: 'padding-box',
};

const THEAD_STYLE = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  background: 'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
  '--bs-table-bg': 'transparent',
  '--bs-table-color': '#fff',
  '--bs-table-border-color': 'rgba(255,255,255,0.15)',
  color: '#fff',
};

/**
 * Tabela com cabeçalho escuro e sticky.
 * @param {React.ReactNode} head  - Conteúdo do <thead> (normalmente um <tr> com <th>s)
 * @param {object}          style - Overrides do estilo inline da <table>
 * @param {React.ReactNode} children - <tbody> e/ou <tfoot>
 */
const DataTable = ({ head, children, style }) => (
  <table
    className="table table-hover table-striped table-sm"
    style={style ? { ...DEFAULT_STYLE, ...style } : DEFAULT_STYLE}
  >
    <thead style={THEAD_STYLE}>
      {head}
    </thead>
    {children}
  </table>
);

export default DataTable;
